import { useEffect, useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { faqBookingRelated, faqPlatformRelated, faqOthers } from "./faqUtil";
import FoldableCardSummerCamp from "./FoldableCardSummerCamp";
import classes from "./faq.module.css";

export default function FAQ({ FAQColor = "white" }) {
  const { width } = useWindowSize();
  const faqTypesData = [
    { id: 1, name: "Platform" },
    { id: 2, name: "Booking" },
    { id: 3, name: "Other" },
  ];
  const [faqData, setFaqData] = useState(faqPlatformRelated);
  const [selectedId, setSelectedId] = useState(1);
  const [isOpenedStates, setIsOpenedStates] = useState(
    Array.from({ length: faqData.length }, () => true)
  );

  useEffect(() => {
    setIsOpenedStates(Array.from({ length: faqData.length }, () => true));
  }, [faqData]);

  const handleItemClick = (id) => {
    setSelectedId(id);
    if (id === 3) setFaqData(faqOthers);
    //faqQuestionSummerCampCustomerSupport
    else if (id === 2) setFaqData(faqBookingRelated);
    //faqQuestionSummerCampClassExperience
    else setFaqData(faqPlatformRelated);
  };

  return (
    <div
      className={`${classes.container}`}
      itemType={"https://schema.org/FAQpage"}
      itemScope=" "
    >
      <div className={classes.roundedImage}></div>
      <div className={classes.faqContents}>
        <div className={classes.faqSubHeading}>Need to Know</div>
        <div className={classes.headingDivContainer}>
          <p className={classes.lessonsTxt} style={{ color: "white" }}>
            {"FAQ"}
          </p>
        </div>
        <div className={classes.faqTypes}>
          {faqTypesData.map(({ id, name }) => (
            <div
              key={id}
              className={`${classes.faqType} ${
                selectedId === id ? classes.selectedFaq : ""
              }`}
              onClick={() => handleItemClick(id)}
            >
              {name}
            </div>
          ))}
        </div>
        {faqData.map(({ id, question, answer }, index) => (
          <FoldableCardSummerCamp
            title={question}
            content={answer}
            key={id}
            withoutBorder={
              index === faqBookingRelated.length - 1 && width < 488
            }
            index={index}
            isOpenedStates={isOpenedStates}
            setIsOpenedStates={setIsOpenedStates}
          />
        ))}
      </div>
    </div>
  );
}
